import React, { useState } from 'react'
import '../css/Pricing.css'
import '../css/PricingModal.css'
import NeighborhoodVideo from '../assets/NeighborhoodClip.mp4'
import HouseVideo from '../assets/HouseClip.mp4'
import { FaTimes } from 'react-icons/fa'
import ReactModal from 'react-modal'
import emailjs from '@emailjs/browser'

const Pricing = () => {

    const [showModal, setShowModal] = useState(false)
    // const [modalType, setModalType] = useState('')


    const OpenHouseModalOnClick = () => {
        setShowModal(true)
        // setModalType("House")
    }

    const OpenHouseBundleModalOnClick = () => {
        setShowModal(true)
        // setModalType("House Bundle")
    }

    // const OpenPersonalModalOnClick = () => {
    //     setShowModal(true)
    //     setModalType("Personal")
    // }

    const SendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLATE_ID, e.target, process.env.REACT_APP_PUBLIC_KEY);
        setShowModal(false)
    }

    // if (showModal) {
    //     document.addEventListener('mousedown', handleClickOutside);
    //   } else {
    //     document.removeEventListener('mousedown', handleClickOutside);
    //   }

    return (
        <div>
            {/* <PricingModal onRequestClose={() => setShowModal(false)} open={showModal} onClose={() => setShowModal(false)} type={modalType}/> */}
            
            <ReactModal ariaHideApp={false} className='modal-container' contentLabel='contact modal' isOpen={showModal} onRequestClose={() => setShowModal(false)}>
                <div className='modal-content'>
                    <div>
                        <p>Contact Us</p>
                        <button className='close-button' onClick={() => setShowModal(false)}><FaTimes className='exit-button' size={30} /></button>
                    </div>

                    <form onSubmit={SendEmail}>
                        <ul className='form-body'>
                            <li>
                                <input name='name' label="name" placeholder="Name" />
                            </li>
                            <li>
                                <input name='email' label="email" placeholder="Email" />
                            </li>
                            <li>
                                <input name='phone' label="phone" placeholder="Phone" />
                            </li>
                            <li>
                                <input name='comment' label="comment" placeholder="Comments" />
                            </li>
                        </ul>
                        <button type='submit' className='button'>Submit</button>
                    </form>
                </div>
            </ReactModal>


            <div className='pricing' id='pricing'>
                <div className='container'>
                    <h2>What We Do</h2>
                    <span className='line' />
                    <div className='content'>
                        <div className='card'>
                            <h3>Residential Real Estate</h3>
                            <span className='border-line' />
                            <video src={HouseVideo} autoPlay loop muted />
                            <p>
                                <span></span>
                            </p>
                            <p>Starting at $75</p>
                            <button className='button' onClick={OpenHouseModalOnClick}>Request a Quote</button>
                        </div>
                        <div className='card'>
                            <h3>Bundle and Save</h3>
                            <span className='border-line' />
                            <video src={NeighborhoodVideo} autoPlay loop muted />
                            <p>
                                <span></span>
                            </p>
                            <p>$60 each for 3+ Properties</p>
                            <button className='button' onClick={OpenHouseBundleModalOnClick}>Request a Quote</button>
                        </div>
                        {/* <div className='card'>
                            <h3>Personal</h3>
                            <span className='border-line' />
                            <video src={HouseVideo} autoPlay loop muted />
                            <p>
                                <span></span>
                            </p>
                            <p>Prices Vary</p>
                            <button className='button' onClick={OpenPersonalModalOnClick}>Request a Quote</button>
                        </div> */}
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Pricing
